import { useNavigate } from "react-router-dom";
import {
  VacancyFinderContainer,
  VacancyFinderFunctionField,
  VacancyFinderProvinceField,
  VacancyFinderSearch,
  VacancyFinderSearchButton,
  VacanyFinderTitle,
} from "./VacancyFinderStyles";
import { useState } from "react";

function VacancyFinder() {
  const navigate = useNavigate(); // Initialize the navigation hook
  const [searchParamQuery, setSearchParamQuery] = useState("");
  const [provinceParamQuery, setProvinceParamQuery] = useState("");

  // Handle search input change
  const handleSearchParamChange = (e) => {
    setSearchParamQuery(e.target.value);
  };

  // Handle province selection change
  const handleProvinceParamChange = (e) => {
    setProvinceParamQuery(e.target.value);
  };

  // Handle form submission (button click)
  const handleSearchSubmit = () => {
    // Navigate to the Vacancies page with query parameters
    navigate(
      `/healthcare/vacancy?search=${searchParamQuery}&province=${provinceParamQuery}`
    );
  };

  return (
    <VacancyFinderContainer>
      <VacanyFinderTitle>
        Vind jou vacature in{" "}
        <span style={{ color: "#17224d" }}>alle vacatures</span>
      </VacanyFinderTitle>
      <VacancyFinderSearch>
        <VacancyFinderFunctionField
          type="text"
          placeholder="Zoek op functie of trefwoord"
          value={searchParamQuery}
          onChange={handleSearchParamChange}
        />
        <VacancyFinderProvinceField
          value={provinceParamQuery}
          onChange={handleProvinceParamChange}
        >
          <option value="">Alle provincies</option>
          <option value="groningen">Groningen</option>
          <option value="friesland">Friesland</option>
          <option value="drenthe">Drenthe</option>
          <option value="overijssel">Overijssel</option>
          <option value="flevoland">Flevoland</option>
          <option value="gelderland">Gelderland</option>
          <option value="utrecht">Utrecht</option>
          <option value="noord-holland">Noord-Holland</option>
          <option value="zuid-holland">Zuid-Holland</option>
          <option value="zeeland">Zeeland</option>
          <option value="noord-brabant">Noord-Brabant</option>
          <option value="limburg">Limburg</option>
        </VacancyFinderProvinceField>
      </VacancyFinderSearch>
      <VacancyFinderSearchButton onClick={handleSearchSubmit}>
        Vind mijn vacature
      </VacancyFinderSearchButton>
    </VacancyFinderContainer>
  );
}

export default VacancyFinder;
